import { render, staticRenderFns } from "./SectionTitleWithIcon.vue?vue&type=template&id=68ee52ce&scoped=true&"
import script from "./SectionTitleWithIcon.vue?vue&type=script&lang=js&"
export * from "./SectionTitleWithIcon.vue?vue&type=script&lang=js&"
import style0 from "./SectionTitleWithIcon.vue?vue&type=style&index=0&id=68ee52ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ee52ce",
  null
  
)

export default component.exports